import {ReactNode} from 'react';

export interface InventoryInfo {
  id: number;
  txn_state: string;
  sku: string;
  description: string;
  alternate_id: string;
  hs_code: string;
  country_of_origin: string;
  cartons_per_layer: number;
  layers_per_pallet: number;
  cartons_per_pallet: number;
  stackable: boolean;
  csa: object;
  serial_number_program: string;
  properties: InventoryProperty[];
  shelf_life_threshold: number;
  temperature: string;
  allergens: string[];
  inventory_group: string;
  review_date: string;
}

export interface InventoryConfiguration {
  inventory_id: number;
  lot_code_tracking_enabled: boolean;
  expiry_date_tracking_enabled: boolean;
  is_hazmat: boolean;
  is_ormd: boolean;
  manufacturing_date_tracking_enabled: boolean;
  bag_and_tape_required: boolean;
  release_date: Date;
  cartons_per_pallet: number;
  custom_reference_1_enabled: boolean;
  custom_reference_2_enabled: boolean;
}

export interface Unit {
  expression: string;
}

export interface InventoryProperty {
  id: number;
  inventory_id: number;
  parent_id: number;
  packaging: string;
  dimension_unit: string | Unit;
  length: number;
  width: number;
  height: number;
  weight_unit: string | Unit;
  weight: number;
  parent: string;
  units_per_parent: number;
  ship_alone: boolean;
  ship_as_is: boolean;
  barcode: string;
  barcode_type: string;
  new_record: boolean;
  retail_amount: string;
  serial_number_capture_mode: string;
  serial_number_capture_required: boolean;
  serial_number_patterns: string[];
}

export interface InventorySummary {
  damaged: InventorySummaryBucket;
  num_stored_pallets: number;
  num_dropoff_pallets: number;
  num_pickup_pallets: number;
  num_stored_cartons: number;
  num_allocated_cartons: number;
  num_stored_eaches: number;
  num_allocated_eaches: number;
  stored: InventorySummaryBucket;
  allocated: InventorySummaryBucket;
  received: InventorySummaryBucket;
  on_hold: InventorySummaryBucket;
  crossdock: InventorySummaryBucket;
  available: InventorySummaryBucket;
  num_available_cartons: number;
  num_available_eaches: number;
}

export interface InventorySummaryBucket {
  each: number;
  carton: number;
  pallet: number;
  inner_pack: number;
}

export interface HazmatViewData {
  is_hazmat: boolean;
  is_ormd: boolean;
}

export interface HazmatClassification {
  un_number: string;
  pkg_code: string;
}

export const UOMS = ['each', 'carton', 'pallet', 'inner_pack'];

export interface ItemMasterMessage {
  msg: string;
  detail?: string;
}

export interface ImportCsvDropdownOption {
  name: ReactNode;
  value: string;
}

export interface InventoryUploadCsvColumnInfo {
  name: string;
  requiredFor: RequiredFor;
  sampleInput: string;
  description: string;
  guidelines: ReactNode[];
}

export interface InventoryUploadCsvColumnInfoGroup {
  columns: InventoryUploadCsvColumnInfo[];
  editableBy: EditableBy;
}

export enum EditableBy {
  Shipper = 'Shipper',
  Warehouse = 'Warehouse',
  ShipperAndWarehouse = 'ShipperAndWarehouse'
}

export enum ModalAction {
  Update = 'Update',
  Create = 'Create'
}

export enum RequiredFor {
  Update = 'Update',
  Create = 'Create',
  UpdateAndCreate = 'UpdateAndCreate',
  NeitherUpdateNorCreate = ''
}
